import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS } from '@contentful/rich-text-types';
import styles from './index.less';
import { CONTENTFUL_LOCAL_EN, CONTENTFUL_LOCAL_ZH } from 'src/utils/contentful';
/**
 * Render a contentful Rich Text document as HTML
 * @param {object} props
 * @param {object} props.document - contentful document to render
 * @param {['normal'|'small']} props.scale - small is 8/10ths normal size.
 */
const ContentfulRichText = ({ document, contentfulLocale = CONTENTFUL_LOCAL_EN, scale = 'normal' }) => {
  const options = {
    renderNode: {
      [BLOCKS.EMBEDDED_ASSET]: (node) => {
        let { title, file } = node.data.target.fields;
        file = file ? file[contentfulLocale] || file[CONTENTFUL_LOCAL_EN] || file : null;
        title = title[contentfulLocale] || title[CONTENTFUL_LOCAL_EN] || title;
        return (
          <React.Fragment>
            {<div>{file ? <img src={file.url} alt={title} style={{ maxWidth: '100%' }} /> : null}</div>}
          </React.Fragment>
        );
      },

      [BLOCKS.HR]: (node) => {
        return (
          <div className={styles.hrWrapper}>
            <hr className={styles.hrbreak} />
          </div>
        );
      },
      [BLOCKS.QUOTE]: (node, children) => {
        return (
          <div className={styles.chowbusBlockquote}>
            <blockquote>{children}</blockquote>
          </div>
        );
      },
    },
  };
  const renderedText = documentToReactComponents(document, options);
  return <div className={styles.contentfulRichText}>{renderedText}</div>;
};

export default ContentfulRichText;
